import React, { useState } from 'react';
import UserContainer from '#components/blocks/user/UserContainer';
import useTranslation from 'next-translate/useTranslation';
import UserName from '#components/blocks/userName/UserName';
import AvatarList from '#modules/profileSelection/avatarlist/AvatarList';
import { useOvermindActions } from '#store/overmind';
import {
  ProfileViews,
  useProfileNavigation,
} from '#modules/profileSelection/useProfileNavigationContext';

enum VIEWS {
  CHOOSE_AVATAR = 'choose-avatar',
  CHOOSE_NAME = 'choose-name',
}

const CreateProfileView = () => {
  const { t } = useTranslation();

  const { createProfile } = useOvermindActions().user;
  const [view, setView] = useState(VIEWS.CHOOSE_AVATAR);
  const [avatarId, setAvatarId] = useState<number | undefined>();
  const [name, setName] = useState<string | undefined>();
  const [loading, setLoading] = useState(false);
  const { setProfileView } = useProfileNavigation();

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const handleAvatarSelect = (id: number) => {
    setAvatarId(id);
  };

  const handleCreateProfile = () => {
    if (!loading) {
      setLoading(true);
      createProfile({ name, avatarAssetId: avatarId })
        .then(() => {
          setProfileView(ProfileViews.SELECT_PROFILE);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  };

  const handleAvatarSelectEnterKey = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      setView(VIEWS.CHOOSE_NAME);
    }
  };

  const handleCreateProfileEnterKey = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleCreateProfile();
    }
  };

  const handleBackToProfileSelection = () => {
    setProfileView(ProfileViews.SELECT_PROFILE);
  };

  if (view === VIEWS.CHOOSE_AVATAR) {
    return (
      <UserContainer
        title={t('createProfile')}
        subtitle={t('chooseAvatar')}
        onClose={handleBackToProfileSelection}
        secondaryButtonText={t('globalButtonsCancel')}
        onSecondaryClick={handleBackToProfileSelection}
        primaryButtonText={t('createProfileChooseUsername', {
          fallback: 'Benutzername wählen',
        })}
        onPrimaryClick={() => setView(VIEWS.CHOOSE_NAME)}
        isSubmitDisabled={!avatarId}
      >
        <div className="tw-my-auto">
          <AvatarList
            title={t('chooseUser')}
            onKeyPress={handleAvatarSelectEnterKey}
            onSelect={handleAvatarSelect}
            selectedAvatarAssetId={avatarId}
          />
        </div>
      </UserContainer>
    );
  }

  if (view === VIEWS.CHOOSE_NAME) {
    return (
      <UserContainer
        title={t('createProfile')}
        subtitle=""
        onClose={handleBackToProfileSelection}
        secondaryButtonText={t('globalButtonsCancel')}
        primaryButtonText={t('globalButtonsSave')}
        onPrimaryClick={handleCreateProfile}
        onSecondaryClick={handleBackToProfileSelection}
        isSubmitDisabled={!name}
      >
        <UserName
          title={t('enterProfileName')}
          placeholder={t('chooseProfileName')}
          avatarAssetId={avatarId}
          value={name}
          onChangeName={handleNameChange}
          onKeyPress={handleCreateProfileEnterKey}
        />
      </UserContainer>
    );
  }
};

export default CreateProfileView;
